import { isProxy, toRaw } from 'vue'
// 防抖
function debounceController(callback, step = 300) {
  let timer
  return () => {
    if (timer) {
      // 清除定时器
      clearTimeout(timer)
    }
    // 定时器
    timer = setTimeout(callback, step)
  }
}

// 空值处理
function formatterEmpty(text) {
  return [undefined, null, ''].includes(text) ? '---' : text
}

// 倒计时（activate参数true为新倒计时，false为处理未结束的旧倒计时）
function countdown(sign, originRef, activate = true, time = 60, step = 1000, statusKey = 'status', textKey = 'text') {
  if (!sign || !originRef) return
  // 关键key
  const key = `wfq_${sign}_countdown`
  // 时间剩余
  let remainTime = time
  if (activate) {
    // 当前时间
    const currentTime = new Date().getTime()
    // 新的计时信息
    const newTimeInfo = {
      time,
      sign,
      saveTime: currentTime,
    }
    // 存储计时信息
    localStorage.setItem(key, JSON.stringify(newTimeInfo))
  } else {
    // 旧的计时信息
    let oldTimeInfo
    try {
      // 是否本地已经存贮计时信息
      const timeInfoStr = localStorage.getItem(key)
      oldTimeInfo = timeInfoStr ? JSON.parse(timeInfoStr) : ''
    } catch (e) {
      oldTimeInfo = ''
    }
    if (oldTimeInfo) {
      // 当前时间
      const currentTime = new Date().getTime()
      // 旧的时间
      const oldTime = oldTimeInfo.saveTime
      // 间隔时间
      const intervalTime = Math.ceil((currentTime - oldTime) / 1000)
      if (intervalTime < time) {
        // 设置剩余需要运行的时间
        remainTime = time - intervalTime
      } else {
        localStorage.removeItem(key)
        return
      }
    } else {
      return
    }
  }
  // 开始倒计时
  originRef.value[statusKey] = true
  originRef.value[textKey] = remainTime
  const timer = setInterval(() => {
    remainTime--
    if (remainTime) {
      originRef.value[textKey] = remainTime
    } else {
      originRef.value[statusKey] = false
      clearInterval(timer)
    }
  }, step)
}

// 生成1-32位随机字符串
function randomStr() {
  function getRandomValue(min, max) {
    return Math.floor(Math.random() * max) + min
  }
  const numList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0]
  const smallList = []
  const bigList = []
  for (let i = 65; i < 91; i++) {
    bigList.push(String.fromCharCode(i))
  }
  for (let i = 97; i < 123; i++) {
    smallList.push(String.fromCharCode(i))
  }
  const strList = numList.concat(...smallList).concat(bigList)
  const strListLen = strList.length
  const newListLen = getRandomValue(1, 32)
  // console.log('strList', strList, strListLen, newListLen);
  let newList = new Array(newListLen)
  for (let i = 0; i < newListLen; i++) {
    const random = getRandomValue(0, strListLen - 1)
    // console.log('random', random);
    newList[i] = strList[random]
  }
  return newList.join('')
}

// 复制对象
function copyObj(originData) {
  if (typeof originData !== 'object' || originData === null) return originData
  // 如果是数组类型
  if (Object.prototype.toString.call(originData) === '[object Array]') {
    let newArr = []
    originData.forEach((item) => {
      // 如果是代理对象，去获取它的原始值
      const isProxyObj = isProxy(item)
      if (isProxyObj) {
        item = toRaw(item)
      }
      newArr.push(copyObj(item))
    })
    return newArr
  } else {
    // 如果是对象类型
    const keyList = Reflect.ownKeys(originData)
    // console.log('copyObj', keyList);
    if (keyList.length > 0) {
      let newObj = {}
      keyList.forEach((item) => {
        let value = originData[item]
        // 如果是代理对象，去获取它的原始值
        const isProxyObj = isProxy(value)
        if (isProxyObj) {
          value = toRaw(value)
        }
        // if (Object.prototype.toString.call(value) === '[object Object]') {
        newObj[item] = copyObj(value)
        // } else {
        //   newObj[item] = value
        // }
      })
      return newObj
    } else {
      return originData
    }
  }
}

// 延迟执行
function delayRun(statusFun, callback, delay = 200, current = 1, count = 10) {
  return new Promise((resolve, reject) => {
    setTimeout(
      () => {
        let result = ''
        const status = statusFun()
        try {
          if (status) {
            result = callback()
          } else {
            // 最大重试次数限制
            if (current <= count) {
              current++
              result = delayRun(statusFun, callback, delay, current, count)
            }
          }
          // console.log('delayRun', result, current);
          resolve(result)
        } catch (e) {
          reject(e)
        }
      },
      current == 1 ? 0 : delay,
    )
  })
}

function copyAction(value) {
  // 创建一个input元素
  const input = document.createElement('input')
  // 给input的内容复制
  input.value = value
  // 在body里面插入这个元素
  document.body.appendChild(input)
  // 选中input里面内容
  input.select()
  // 执行document里面的复制方法1
  document.execCommand('Copy')
  // 复制之后移除这个元素
  document.body.removeChild(input)
}

// 获取url参数
function getUrlParams(key, url = window.location.href) {
  const params = url.split('?')[1]
  // console.log('getUrlParams', params);
  if (!params) return ''
  const paramsList = params.split('&')
  if (paramsList && paramsList.length > 0) {
    let paramsObj = {}
    paramsList.forEach((item) => {
      const itemList = item.split('=')
      paramsObj[itemList[0]] = itemList[1]
    })
    const selectedValue = paramsObj[key]
    return selectedValue || ''
  } else {
    return ''
  }
}

function getShortcuts(text, number) {
  return {
    text,
    value: () => {
      const date = new Date()
      if (number) {
        date.setTime(date.getTime() + 3600 * 1000 * 24 * number)
        return date
      }
      return date.getTime()
    },
  }
}

export { debounceController, formatterEmpty, countdown, randomStr, copyObj, delayRun, copyAction, getUrlParams, getShortcuts }
